import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import anime from 'animejs/lib/anime.es.js';
import { ChevronLeft, Music } from 'lucide-react';

const TEX_RVRE = 'https://customer-assets.emergentagent.com/job_ac09e30e-ff84-4be5-9a8e-38b36c255d06/artifacts/1x77s1n5_Honor%20MagicOS%209%20Wallpaper%20-6.jpg';

export default function ArtistRVRE() {
  const heroRef = useRef(null);

  useEffect(() => {
    document.title = 'RVRE // VVS';
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced || !heroRef.current) return;

    anime.timeline({ easing: 'easeOutExpo' })
      .add({ targets: '.rvre-back', translateX: [-20, 0], opacity: [0, 1], duration: 600 })
      .add({ targets: '.rvre-tag', translateY: [20, 0], opacity: [0, 1], duration: 600 }, '-=300')
      .add({ targets: '.rvre-name', translateY: [60, 0], opacity: [0, 1], duration: 900 }, '-=400')
      .add({ targets: '.rvre-body', translateY: [30, 0], opacity: [0, 1], duration: 700 }, '-=500')
      .add({ targets: '.rvre-sc', translateY: [20, 0], opacity: [0, 1], duration: 600 }, '-=300');
  }, []);

  return (
    <div style={{ position: 'relative', zIndex: 1, paddingTop: '64px' }}>
      {/* Hero */}
      <section ref={heroRef} style={{ minHeight: '90vh', position: 'relative', display: 'flex', alignItems: 'flex-end', overflow: 'hidden' }}>
        <img src={TEX_RVRE} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.25 }} />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(160deg, rgba(0,20,60,0.4) 0%, transparent 60%, rgba(5,10,20,0.8) 100%)' }} />
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '60%', background: 'linear-gradient(to top, var(--vvs-bg) 0%, transparent 100%)' }} />

        <div style={{ position: 'relative', padding: '80px 48px', width: '100%' }}>
          <Link to="/artists" className="rvre-back" data-testid="rvre-back" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: 'var(--vvs-muted)', textDecoration: 'none', fontSize: '11px', letterSpacing: '0.15em', textTransform: 'uppercase', fontFamily: 'Space Grotesk', marginBottom: '32px', opacity: 0, transition: 'color 0.3s' }}
            onMouseEnter={e => e.currentTarget.style.color = '#F0F4F8'}
            onMouseLeave={e => e.currentTarget.style.color = 'var(--vvs-muted)'}
          >
            <ChevronLeft size={14} /> Artists
          </Link>

          <p className="rvre-tag caption" style={{ marginBottom: '16px', color: 'var(--vvs-cyan)', opacity: 0 }}>
            Incoming Signal
          </p>

          <h1 className="rvre-name" style={{
            fontFamily: 'Syne, sans-serif', fontWeight: 800,
            fontSize: 'clamp(60px, 10vw, 130px)',
            lineHeight: 0.88, letterSpacing: '-0.04em', textTransform: 'uppercase',
            color: '#F0F4F8', margin: '0 0 32px', opacity: 0,
          }}>
            RVRE
          </h1>

          <div className="rvre-body" style={{ maxWidth: '480px', opacity: 0 }}>
            <p style={{ fontFamily: 'Space Grotesk, sans-serif', fontSize: 'clamp(18px, 2.5vw, 26px)', lineHeight: 1.5, color: 'var(--vvs-steel)', marginBottom: '16px', fontStyle: 'italic' }}>
              "Something is forming.<br />Stay close."
            </p>
            <p style={{ fontFamily: 'Space Grotesk, sans-serif', fontSize: '14px', color: 'var(--vvs-muted)', lineHeight: 1.7 }}>
              A portal in construction. No timeline. No details.<br />Only the signal, when it arrives.
            </p>
          </div>
        </div>
      </section>

      {/* Back to Artists */}
      <section style={{ padding: '60px 48px 100px' }}>
        <div style={{ maxWidth: '700px', margin: '0 auto', display: 'flex', justifyContent: 'center' }}>
          <Link to="/artists" className="btn-metallic" style={{ textDecoration: 'none', display: 'inline-block' }} data-testid="rvre-back-btn">
            ← Back to Artists
          </Link>
        </div>
      </section>
    </div>
  );
}
